import { render } from "./ShipmentLabelList.vue?vue&type=template&id=0534c3db&ts=true"
import script from "./ShipmentLabelList.vue?vue&type=script&lang=ts"
export * from "./ShipmentLabelList.vue?vue&type=script&lang=ts"

import "./ShipmentLabelList.vue?vue&type=style&index=0&id=0534c3db&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__